import { jsx as t, jsxs as e } from "react/jsx-runtime";
import { Button as _ } from "../../atoms/Button/Button.es.js";
import { FloatingBottomBar as B } from "../../atoms/FloatingBar/FloatingBottomBar.es.js";
import { useNoSSRBreakpointValue as M } from "../../hooks/useNoSSRBreakpointValue.es.js";
import { useMultiStyleConfig as F, chakra as i } from "@chakra-ui/react";
import { FloatingActionWrapper as v } from "./FloatingActionWrapper.es.js";
import { FloatingBottomMultiselectActions as u } from "./FloatingBottomMultiselectActions.es.js";
import { FloatingBottomMultiselectClose as g } from "./FloatingBottomMultiselectClose.es.js";
import { FloatingBottomMultiselectItemsSelected as h } from "./FloatingBottomMultiselectItemsSelected.es.js";
const N = ({
  closeButtonProps: p,
  isOpen: s = !1,
  numberOfItems: a,
  onClose: l,
  primary: n = {},
  remove: c,
  secondary: m,
  selectAll: r,
  tertiary: d,
  ...f
}) => {
  const o = F("FloatingBottomMultiselectActions");
  return M({ base: !0, sm: !0, md: !1 }) ? /* @__PURE__ */ t(B, { isOpen: s, sx: o.floatingBar, ...f, children: /* @__PURE__ */ e(i.div, { __css: o.floatingBarContainerBase, children: [
    /* @__PURE__ */ e(i.div, { __css: o.floatingBarActionsContainerBase, children: [
      /* @__PURE__ */ t(h, { numberOfItems: a }),
      /* @__PURE__ */ e(i.div, { __css: o.floatingBarHeader, children: [
        r && /* @__PURE__ */ t(v, { tooltip: r.tooltip, children: /* @__PURE__ */ t(_, { variant: "transparent", ...r, size: "md", children: "Select all" }) }),
        /* @__PURE__ */ t(g, { onClose: l })
      ] })
    ] }),
    /* @__PURE__ */ t(i.hr, { __css: { ...o.divider, width: "auto" } }),
    /* @__PURE__ */ t(
      u,
      {
        primary: n,
        remove: c,
        secondary: m,
        tertiary: d
      }
    )
  ] }) }) : /* @__PURE__ */ e(B, { isOpen: s, sx: o.floatingBar, ...f, children: [
    /* @__PURE__ */ t(h, { numberOfItems: a }),
    /* @__PURE__ */ t(i.hr, { __css: o.divider }),
    /* @__PURE__ */ t(
      u,
      {
        primary: n,
        remove: c,
        secondary: m,
        tertiary: d,
        selectAll: r
      }
    ),
    /* @__PURE__ */ t(i.hr, { __css: o.divider }),
    /* @__PURE__ */ t(g, { onClose: l, ...p })
  ] });
};
export {
  N as FloatingBottomMultiselect
};
//# sourceMappingURL=FloatingBottomMultiselect.es.js.map
